import axios from 'axios'
import { v4 as uuid_v4 } from 'uuid'
import qs from 'qs'

const axiosInstanceExtension = axios.create({
    baseURL: '/services/plugin-extension-google/',
    headers: {
        'Access-Control-Allow-Origin': '*'
    }
})

const axiosInstance = axios.create({
    baseURL: '/services/plugin-extension-google/',
    headers: {
        'Access-Control-Allow-Origin': '*'
    }
})

export interface LatLngReverse {
    id?: any
    lat: number
    lng: number
}

const cacheGoogleGeocode: any = {}
let extensionQualifier = ''
let apiMapKey = ''

axiosInstance.interceptors.request.use(
    request => {
        if (!sessionStorage.sessionToken) {
            sessionStorage.sessionToken = uuid_v4()
        }

        if (extensionQualifier.length > 0) {
            request.baseURL += extensionQualifier
        }

        request.headers.sessionToken = sessionStorage.sessionToken

        return request
    },
    error => {
        return Promise.reject(error)
    }
)

export const getExtensionsQualifier = () => {
    return axiosInstanceExtension.get('/extension-service')
}

export const getAutocomplete = (query: string) => {
    return axiosInstance.get('/autocomplete', {
        params: { query }
    })
}

export const getPlaceDetails = (placeId: string) => {
    return axiosInstance.get('/details', {
        params: { placeId }
    })
}

export const getDirections = (origin: string, destination: string, wayPoints?: string[], optimized?) => {
    return axiosInstance.get('/directions', {
        params: { origin, destination, optimized, wayPoints },
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'repeat' })
        }
    })
}

export const getReverseGeocoding = (latLngs: string[]) => {
    return axiosInstance.get('/reverse-geocode', {
        params: { latLngs },
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'repeat' })
        }
    })
}

export const getApiWebKey = () => {
    return axiosInstance.get('/api-web-key')
}

export const clearSessionToken = () => {
    delete sessionStorage.sessionToken
}

export const getCacheGoogleGeocode = key => {
    return cacheGoogleGeocode[key]
}

export const setCacheGoogleGeocode = (keyCache, addressComponents, lat, lon) => {
    if (!cacheGoogleGeocode[keyCache]) cacheGoogleGeocode[keyCache] = {}
    cacheGoogleGeocode[keyCache] = { addressComponents, lat, lon }
}

export const formatAddress = (addressComponents: any[] = [], formattedAddress: string) => {
    if (addressComponents.length === 0) return ''

    const aux: string[] = []

    addressComponents.forEach(ele => {
        ele.types.forEach(type => {
            if (type.toLowerCase() === 'route' || type.toLowerCase() === 'sublocality') {
                aux.push(ele.longName)
            }
        })
    })

    if (aux.length===0) return formattedAddress

    return aux.join(', ')
}

export const setExtensionQualifier = newExtensionQualifier => {
    extensionQualifier = newExtensionQualifier
}

export const getApiMapKey = () => {
    return apiMapKey
}

export const setApiMapKey = newApiMapKey => {
    return (apiMapKey = newApiMapKey)
}

export const fillGoogleReverseGeocode = async (reverseGeocoding, latLngReverse: LatLngReverse[]) => {
    const geocodeResult: any = { ...reverseGeocoding }
    const latLngs: any[] = []

    if (latLngReverse) {
        latLngReverse.forEach(({ lat, lng }) => {
            const id = `${lat.toFixed(5)}/${lng.toFixed(5)}`
            const valueInCache = getCacheGoogleGeocode(id)

            if (!geocodeResult[id]) geocodeResult[id] = {}

            if (valueInCache && valueInCache.lat === lat && valueInCache.lng === lng) {
                geocodeResult[id].address = formatAddress(valueInCache?.addressComponents, valueInCache?.formattedAddress)
            } else {
                latLngs.push({ id, lat, lng })
            }
        })
    }

    if (latLngs.length > 0) {
        let startPosition = 0
        const sizePageAux = 150
        let latLangAux = [...latLngs]

        while (startPosition < latLngs.length) {
            // Prevent overflow size query request

            latLangAux = latLangAux.splice(startPosition, startPosition + sizePageAux)
            const latLngs: string[] = []

            latLangAux.forEach(ele => {
                latLngs.push(`${ele.lat},${ele.lng}`)
            })

            await getReverseGeocoding(latLngs).then(response => {
                for (const index in latLangAux) {
                    const { lat, lng } = latLangAux[index]
                    const id = buildReverseGeocodeId(lat, lng)
                    let addressComponents: any[] = []
                    let formattedAddress: string = ""

                    if (response.data[index] != null && response.data[index].geocodingResult != null) {
                        addressComponents = response.data[index].geocodingResult.addressComponents
                        formattedAddress = response.data[index].geocodingResult.formattedAddress
                    }

                    setCacheGoogleGeocode(id, addressComponents, lat, lng)
                    geocodeResult[id].address = formatAddress(addressComponents, formattedAddress)
                }
            })

            startPosition = startPosition + sizePageAux + 1
        }
    }

    return geocodeResult
}

export const buildReverseGeocodeId = (lat, lng) => {
    if (!lat || !lng) return

    return `${lat.toFixed(5)}/${lng.toFixed(5)}`
}
